import React from 'react'
import { connect } from 'react-redux'
import { Icon, Tooltip } from "antd"
import "./pdf-tag.css"
import PdfTag from './PdfTag'
import { injectIntl } from 'react-intl'
import { unsetIsPdfTagActive } from '../../../actions/CommentAction'
class DinamicPdfTag extends React.Component {


    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { pdfCarouselIndex, isPdfTagActive, versionNumber, intl, unsetIsPdfTagActive } = this.props
        return (
            <React.Fragment>
                <div className='flex-tag-parent' >
                    <p>{intl.formatMessage({ id: "tagging_on_page" })} &nbsp; </p>
                    <PdfTag
                        isPdfTagActive={isPdfTagActive}
                        pdfCarouselIndex={pdfCarouselIndex}
                        versionNumber={versionNumber}
                    />
                    <p>&nbsp;&nbsp;</p>
                    <Tooltip placement='top' title={intl.formatMessage({ id: "delete_pdf_tag" })}>
                        <p className='cursor-pointer' onClick={unsetIsPdfTagActive}><Icon type="close-circle" /></p>
                    </Tooltip>

                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    pdfCarouselIndex: state.comments.pdfCarouselIndex,
    isPdfTagActive: state.comments.isPdfTagActive,
    versionNumber: state.comments.itemSelected.document.versionNumber

})

const mapDispatchToProps = {
    unsetIsPdfTagActive
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DinamicPdfTag))
